import { network } from 'services/network';
import { useMutation } from 'react-query';

const mutationFn = (params) => {
    return network.post('api/bo/removeVersion', { ids: params.ids });
};
export const useMutationRemoveXerFile = () => {
    return useMutation<any, QueryError, RemoveXerVersion>({ mutationFn: (params) => mutationFn(params) });
};

interface RemoveXerVersion {
    ids: number[];
}
